import { Control } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { BirthDateControl } from './BirthDateControl'
import { DocumentExpeditionControl } from './DocumentExpeditionControl'
import { DocumentNumberControl } from './DocumentNumberControl'
import { DocumentTypeControl } from './DocumentTypeControl'

import { ContainerGroupField } from '@/components/common'
import { BasicInfoFormData } from '@/types/forms/basicInfoForm'

interface IdControlProps {
    control: Control<BasicInfoFormData>
    watchDocumentType: string
    watchCountryExpedition: string
    watchDepartmentExpedition: string
    handleFieldChange: (field: string, value: string) => void
    watchBirthDate: string
    setIsMinor: (isMinor: boolean) => void
    trigger?: (name: keyof BasicInfoFormData) => Promise<boolean>
    text: string
    disableIdFields: boolean
    isFormTouched?: boolean
}

export const IdControl = ({
    control,
    watchDocumentType,
    watchCountryExpedition,
    watchDepartmentExpedition,
    handleFieldChange,
    watchBirthDate,
    setIsMinor,
    trigger,
    text,
    disableIdFields,
    isFormTouched = false
}: IdControlProps): JSX.Element => {
    const { t } = useTranslation()

    return (
        <ContainerGroupField tittleGroup={t('forms.groups.documentType')}>
            <DocumentTypeControl
                control={control}
                isDisabled={disableIdFields}
            />

            <DocumentNumberControl
                control={control}
                watchDocumentType={watchDocumentType}
                text={text}
                isDisabled={disableIdFields}
            />

            <BirthDateControl
                control={control}
                text={text}
                setIsMinor={setIsMinor}
                watchDocumentType={watchDocumentType}
                watchBirthDate={watchBirthDate}
                trigger={trigger}
            />

            <DocumentExpeditionControl
                control={control}
                watchDepartmentExpedition={watchDepartmentExpedition}
                watchCountryExpedition={watchCountryExpedition}
                handleFieldChange={handleFieldChange}
                watchBirthDate={watchBirthDate}
                watchDocumentType={watchDocumentType}
                text={text}
                trigger={trigger}
                isFormTouched={isFormTouched}
            />
        </ContainerGroupField>
    )
}
